export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/es-mx.lyaml"));
at({ "es-mx": { "public": { "sampleString": "Cadena de ejemplo" } } });
};